import { Grid } from '@mui/material';
import GridContainer from 'components/GridContainer';
import { Row } from 'components/Layout';
import React, { PropsWithChildren } from 'react';
import FilterButton, { FilterButtonProps } from './FilterButton';
import DropdownActions, { DropdownAction } from 'components/DropdownActions';

export { default as Filter } from './Filter';

type Props = {
  pageId: string;
  buttons?: Array<FilterButtonProps>;
  dropdownActions?: Array<DropdownAction>;
  dropdownActionsLabel?: string;
  exportComponent?: React.ReactNode;
  className?: string;
};

const PageFilters: React.FC<PropsWithChildren<Props>> = ({
  pageId,
  children,
  buttons,
  dropdownActions,
  dropdownActionsLabel = 'Actions',
  exportComponent,
  className,
}) => {
  return (
    <GridContainer
      alignContent="center"
      alignItems="center"
      marginBottom="10px"
      className={className}
    >
      <Grid size={{ xs: 12, md: 'grow' }}>
        <Row spacing="md" centered breakpoint="md" fullWidth>
          {children}
        </Row>
      </Grid>
      {!!buttons?.length && (
        <Grid size={{ xs: 12, md: 'auto' }}>
          <Row spacing="xs" centered>
            {buttons.map((buttonProps, index) => (
              <FilterButton
                key={`${pageId}-filter-button-${buttonProps.link ?? index}`}
                {...buttonProps}
              />
            ))}
          </Row>
        </Grid>
      )}
      {!!dropdownActions?.length && (
        <Grid size={{ xs: 12, md: 'auto' }}>
          <DropdownActions
            id={`${pageId}-dropdown-actions`}
            actions={dropdownActions}
            title={dropdownActionsLabel}
          />
        </Grid>
      )}
      {exportComponent ? (
        <Grid size={{ xs: 12, md: 'auto' }}>{exportComponent}</Grid>
      ) : null}
    </GridContainer>
  );
};

export default PageFilters;
